import * as React from "react";
import { Alert } from "../../../../Shared/Components/Alert";
import { AlertType } from "../../../../Shared/Entities/Constants/AlertConstants";
import { IProcessComponentProps, ProcessComponent } from "../../../../Shared/Process/Process/ProcessComponent";

interface IValidateProps extends IProcessComponentProps {}

interface IValidateState {}

export class Validate extends ProcessComponent<IValidateProps, IValidateState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <>
                <h3>Validate and execute</h3>
                <Alert alertType={AlertType.Success} message={"All data entered has been successfully validated."} />
                <p>To confirm that you wish to proceed to the final step, click here.</p>
            </>
        );
    }
}
